import type { QuerySettings } from '@customTypes/index';
import type { SearchParams } from '@customTypes/types';
import { useInfiniteQuery } from '@tanstack/react-query';

import { searchArtists } from '@/features/search/api/search-artists/request';

export const useSearchArtists = (
  params?: SearchParams,
  settings?: QuerySettings<typeof searchArtists>
) =>
  useInfiniteQuery({
    queryKey: ['searchArtists', params?.countries],
    queryFn: ({ pageParam = 1 }) =>
      searchArtists({
        config: {
          ...settings?.config,
          params: {
            countries: params?.countries,
            pageNumber: pageParam
          }
        }
      }),

    getNextPageParam: (currentPage) =>
      currentPage.data.pageNumber + 1 > currentPage.data.totalPages
        ? null
        : currentPage.data.pageNumber + 1,

    getPreviousPageParam: (currentPage) =>
      currentPage.data.pageNumber - 1 < currentPage.data.totalPages
        ? null
        : currentPage.data.pageNumber - 1,

    initialPageParam: 1
  });
